export default "__VITE_ASSET__Du0sbuVM__"